import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';

export const thriveCodeMirrorTheme = createTheme({
    theme: 'light',
    settings: {
        lineHighlight: '#f5f5f5',
        background: '#ffffff',
        backgroundImage: '',
        foreground: '#657d98',
        caret: '#213444',
        selection: '#D2D9E1',
        selectionMatch: '#f5f5f5',
        gutterBackground: '#FAFAFA',
        gutterForeground: '#213444',
        gutterBorder: '#d2d9e1',
        gutterActiveForeground: '',
    },
    styles: [
        { tag: t.comment, color: '#c5c5c5' },
        { tag: t.name, color: '#f7f7f7' },
        { tag: t.definition(t.typeName), color: '#213444' },
        { tag: t.typeName, color: '#213444' },
        { tag: t.tagName, color: '#213444' },
        { tag: t.variableName, color: '#213444' },
        { tag: t.propertyName, color: '#6d7c99' },
        { tag: t.className, color: '#5c6166' },
        { tag: t.string, color: '#5c6166' },
        { tag: t.url, color: '#1852af' },
        { tag: t.arithmeticOperator, color: '#ff037a' },
        { tag: t.logicOperator, color: '#ff037a' },
        { tag: t.bitwiseOperator, color: '#ff037a' },
        { tag: t.punctuation, color: '#ff037a' },
        { tag: t.bracket, color: '#343d4c' },
        { tag: t.heading, color: '#343d4c' },
        { tag: t.link, color: '#106de0' },
    ],
});